var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('span',[_vm._v("合计："),_c('strong',[_vm._v(_vm._s(_vm.total))])]),_c('button',{staticClass:"clear-todo",on:{"click":_vm.clear}},[_vm._v("清空任务")])])
}
var staticRenderFns = []

export { render, staticRenderFns }